import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppStoreBadges from "./AppStoreBadges";
import "./clientTheme.css";
import "./AppPromoModal.css";

const FIRST_VISIT_KEY = "salatty_app_promo_seen";
const SESSION_KEY = "salatty_app_promo_session";

// Storage can throw in private mode or when site data is blocked.
function readFlag(storage, key) {
  try {
    return storage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeFlag(storage, key) {
  try {
    storage.setItem(key, "1");
  } catch {
    // ignore
  }
}

export function isFirstVisit() {
  return !readFlag(window.localStorage, FIRST_VISIT_KEY);
}

// The promo is shown at most once per browser session, whichever way it appears.
export function wasPromoShownThisSession() {
  return readFlag(window.sessionStorage, SESSION_KEY);
}

export function markPromoShown() {
  writeFlag(window.localStorage, FIRST_VISIT_KEY);
  writeFlag(window.sessionStorage, SESSION_KEY);
}

// The promo body on its own, so the login modal can show it as a first step.
export function AppPromoContent({ onClose, onContinue }) {
  const { t } = useTranslation(["mainPage", "common"]);

  return (
    <div className="app-promo">
      <button type="button" className="app-promo-close" aria-label={t("common:close")} onClick={onClose}>
        &times;
      </button>

      <div className="app-promo-hero">
        <span className="app-promo-discount" dir="ltr">12%</span>
        <span className="app-promo-chip">{t("promoBadge")}</span>
      </div>

      <h2 className="app-promo-title">{t("promoTitle")}</h2>
      <p className="app-promo-subtitle">{t("promoSubtitle")}</p>

      <AppStoreBadges />

      {onContinue ? (
        <button type="button" className="app-promo-continue" onClick={onContinue}>
          {t("promoContinue")}
        </button>
      ) : (
        <button type="button" className="app-promo-later" onClick={onClose}>
          {t("promoMaybeLater")}
        </button>
      )}
    </div>
  );
}

export default function AppPromoModal({ onClose }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="app-promo-overlay" onMouseDown={onClose}>
      <div className="app-promo-modal" role="dialog" aria-modal="true" onMouseDown={(e) => e.stopPropagation()}>
        <AppPromoContent onClose={onClose} />
      </div>
    </div>
  );
}
